import {
	type AsyncIntlProviderComponent,
	createAsyncIntlProvider,
} from '@atlaskit/intl-messages-provider/async';

import messages from '../../../i18n/en';

import { asyncLanguages } from './async-languages';

/**
 * Provides the i18n messages for the GlobalMoreMenu component.
 *
 * Wraps children in an `IntlMessagesProvider` configured with this package's
 * default English messages and async loaders for all supported locales.
 *
 * Pass `disabled` to opt out of message loading (e.g. for Jira, which provides
 * its own intl context and does not want this loader to run).
 */
export const AsyncIntlProvider: AsyncIntlProviderComponent = createAsyncIntlProvider({
	defaultMessages: messages,
	asyncLanguages,
});
